var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 44C84 49.2529 82.9654 54.4543 80.9552 59.3073C78.945 64.1604 75.9986 68.5699 72.2843 72.2843C68.5699 75.9986 64.1604 78.945 59.3073 80.9552C54.4543 82.9654 49.2529 84 44 84C38.7471 84 33.5457 82.9654 28.6927 80.9552C23.8396 78.945 19.4301 75.9986 15.7157 72.2843C12.0014 68.5699 9.05501 64.1604 7.04482 59.3073C5.03463 54.4543 4 49.2529 4 44C4 38.7471 5.03463 33.5457 7.04482 28.6927C9.05501 23.8396 12.0014 19.4301 15.7157 15.7157C19.4301 12.0014 23.8396 9.055 28.6927 7.04482C33.5457 5.03463 38.7471 4 44 4C49.2529 4 54.4543 5.03463 59.3073 7.04482C64.1604 9.05501 68.5699 12.0014 72.2843 15.7157C75.9986 19.4301 78.945 23.8396 80.9552 28.6927C82.9654 33.5457 84 38.7471 84 44L84 44Z",
    stroke: "#E6F4F0",
    strokeWidth: 8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84 44C84 52.4472 81.3258 60.6775 76.3607 67.5114C71.3956 74.3453 64.3944 79.4319 56.3607 82.0423",
    stroke: "#11B55F",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.f9f5ac149e9c1774488c08d5a59470c8.svg";
export { ForwardRef as ReactComponent };